import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useI18n } from "@/i18n";

export default function VerifyEmail() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("working");
  const [error, setError] = useState("");

  useEffect(() => {
    const run = async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setState("done");
      } catch (e) {
        setError(formatApiErrorDetail(e.response?.data?.detail));
        setState("error");
      }
    };
    if (token) run();
    else setState("error");
  }, [token]);

  return (
    <div className="grid min-h-screen place-items-center bg-bg p-6">
      <div className="w-full max-w-sm rounded-2xl border border-line bg-surface p-8 text-center" data-testid="verify-card">
        {state === "working" && <p className="font-mono text-sm text-muted" data-testid="verify-working">{t("Verifying your email…")}</p>}
        {state === "done" && (
          <>
            <p className="font-display text-2xl font-extrabold text-good" data-testid="verify-success">{t("Email verified")}</p>
            <p className="mt-2 text-sm text-muted">{t("Everything is set. AI features are unlocked once your plan is active.")}</p>
            <Link to="/app" className="mt-6 inline-block rounded-full bg-accent px-6 py-2.5 text-sm font-bold text-white" data-testid="verify-open-app">{t("Open Jobky")}</Link>
          </>
        )}
        {state === "error" && (
          <>
            <p className="font-display text-2xl font-extrabold text-bad" data-testid="verify-error">{t("Could not verify")}</p>
            <p className="mt-2 text-sm text-muted">{error || t("This link is missing its token.")}</p>
            <Link to="/login" className="mt-6 inline-block rounded-full bg-accent px-6 py-2.5 text-sm font-bold text-white">{t("Go to login")}</Link>
          </>
        )}
      </div>
    </div>
  );
}
